export default __webpack_public_path__ + "static/media/connect.20457a11.svg";